var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHelpCircle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0001 7.99998C11.1511 7.99998 10.4001 8.61772 10.4001 9.59998H8.8001C8.8001 7.80503 10.1981 6.39998 12.0001 6.39998C13.8021 6.39998 15.2001 7.91931 15.2001 9.71426C15.2001 11.2328 14.1994 12.5541 12.8001 12.925V14.4H11.2001V11.4285H12.0001C12.8491 11.4285 13.6001 10.6965 13.6001 9.71426C13.6001 8.73201 12.8491 7.99998 12.0001 7.99998Z",
    fill: "#453F72"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2001 16H12.8001V17.6H11.2001V16Z",
    fill: "#453F72"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0001 3.19998C7.13999 3.19998 3.2001 7.13987 3.2001 12C3.2001 16.8601 7.13999 20.8 12.0001 20.8C16.8602 20.8 20.8001 16.8601 20.8001 12C20.8001 7.13987 16.8602 3.19998 12.0001 3.19998ZM1.6001 12C1.6001 6.25621 6.25634 1.59998 12.0001 1.59998C17.7439 1.59998 22.4001 6.25621 22.4001 12C22.4001 17.7437 17.7439 22.4 12.0001 22.4C6.25634 22.4 1.6001 17.7437 1.6001 12Z",
    fill: "#453F72"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpCircle);
export default __webpack_public_path__ + "static/media/help-circle.aead93eef04b52105709da973e3f8644.svg";
export { ForwardRef as ReactComponent };